

import { createStyles } from "antd-style";

export const useStyles = createStyles(
  (
    { css, cx },
  ) => {

    return {
      container: cx(
        css`
          .ant-modal-wrap{
              .ant-modal{
                width: fit-content !important;
              }
          }
        `,
      ),
      baseContainer: css`
        max-width: 100%;
        overflow-y: scroll;
        position: relative;
        width: 640px;
        max-height: calc(100vh - 160px);
        ::-webkit-scrollbar {
          display: none;
        }
    
        @media (max-width: 880px) {
          width: 100%;
          max-height: calc(100vh - 16px);
        }
      `,
      titleContainer: css`
        display: flex;
        justify-content: space-between;
        align-items: center;
        position: sticky;
        top: 0;
        z-index: 100;
        width: 100%;
        min-height: 24px;
      `,
    };
  },
  {
    hashPriority: "low",
  },
);
